import { call, put, takeLatest } from 'redux-saga/effects';
import {
    GET_PROFILE_DETAILS,
    GET_PROFILE_DETAILS_SUCCESS,
    GET_PROFILE_DETAILS_FAILURE,
    SAVE_PROFILE_DETAILS,
    SAVE_PROFILE_DETAILS_FAILURE,
    UPDATE_PROFILE_DETAILS,
    UPDATE_PROFILE_DETAILS_FAILURE,
} from '../Action/actionTypes';
import {
    getProfileDetailsApi,
    saveProfileDetailsApi,
    updateProfileDetailsApi,
} from '../../services/profileDetailsAPI'; // Make sure this file exists at the specified path
import { apiCallFailure, apiCallRequest, apiCallSuccess } from '../Action/Action';

function* getProfileDetailsSaga(): Generator {
    try {
        const response: any = yield call(getProfileDetailsApi);
        const type = response?.result?.length > 0 ? response?.result[0]?.userType : "";
        const isLoggedInFirstTime = response?.result?.length <= 0;
        yield put({ type: GET_PROFILE_DETAILS_SUCCESS, payload: { type: type, isLoggedInFirstTime: isLoggedInFirstTime, initialSatge: false } });

    } catch (error: any) {
        yield put({ type: GET_PROFILE_DETAILS_FAILURE, payload: error.message });
    }
}

function* saveProfileDetailsSaga(action: any): Generator {
    try {
        yield put(apiCallRequest());
        const response: any = yield call(saveProfileDetailsApi, action.payload);
        if (response.statusCode === 200) {
            yield put(apiCallSuccess("Your changes have been saved successfully."));
            yield put({ type: GET_PROFILE_DETAILS_SUCCESS, payload: { type: '', isLoggedInFirstTime: false, initialSatge: true } });
            if (action.meta?.onSuccess) {
                console.log("Triggering onSuccess callback...");
                action.meta.onSuccess();
            }
        }
    } catch (error: any) {
        yield put(
            apiCallFailure(
                "An error occurred while saving your changes. Please try again."
            )
        );
        yield put({ type: SAVE_PROFILE_DETAILS_FAILURE, payload: error.message });
    }
}

function* updateProfileDetailsSaga(action: any): Generator {
    try {
        yield put(apiCallRequest());
        const response: any = yield call(updateProfileDetailsApi, action.payload);
        if (response.statusCode === 200) {
            yield put(apiCallSuccess("Your changes have been saved successfully."));
        }
        yield put({ type: GET_PROFILE_DETAILS_SUCCESS, payload: { type: '', isLoggedInFirstTime: false, initialSatge: true } });
        if (action.meta?.onSuccess) {
            console.log("Triggering onSuccess callback...");
            action.meta.onSuccess();
        }
    } catch (error: any) {
        yield put(
            apiCallFailure(
                "An error occurred while saving your changes. Please try again."
            )
        );
        yield put({ type: UPDATE_PROFILE_DETAILS_FAILURE, payload: error.message });
    }
}

export default function* profileDetailsSaga(): Generator {
    yield takeLatest(GET_PROFILE_DETAILS, getProfileDetailsSaga);
    yield takeLatest(SAVE_PROFILE_DETAILS, saveProfileDetailsSaga);
    yield takeLatest(UPDATE_PROFILE_DETAILS, updateProfileDetailsSaga);
}